import {createApp} from 'vue';
import EmployeeTable from './EmployeeTable';
import {createBootstrap} from 'bootstrap-vue-next'
import VueMultiselect from 'vue-multiselect';

$(document).ready(/\/faculty-management\/employee$/.test(window.location.pathname)&&function() {
  const container = $('#employee-container');

  createApp(EmployeeTable, container.data())
      .use(createBootstrap())
      .component('VMultiselect', VueMultiselect)
      .mount(container[0]);
});
